import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'CE Progress|History Voucher Progress';
type SPVoucherFeeBatchesLocs =
	| 'SPCeVoucherProgressTitle'
	| 'SPCeVoucherProgressName'
	| 'SPCeVoucherProgressTotalFees'
	| 'SPCeVoucherProgressFeesPaid'
	| 'SPCeVoucherProgressFeesRemaining'
	| 'SPCeVoucherProgressFeeDueDate'
	| 'SPCeVoucherProgressCompletionPercentage'
	| 'SPCeVoucherProgressViewButton';

export const sPVoucherFeeBatchesLocs: LocDefs<SPVoucherFeeBatchesLocs> = {
	SPCeVoucherProgressTitle: {
		defaultValue: 'Continuing Education Voucher Progress',
		description: 'Title for the continuing education voucher progress page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressName: {
		defaultValue: 'Name',
		description: 'Label for the name input field.',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressTotalFees: {
		defaultValue: 'Total Fees',
		description: 'Label for the total fees input field.',
		displayPath: `${dpRoot}|Total Fees`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressFeesPaid: {
		defaultValue: 'Fees Paid',
		description: 'Label for the fees paid input field.',
		displayPath: `${dpRoot}|Fees Paid`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressFeesRemaining: {
		defaultValue: 'Fees Remaining',
		description: 'Label for the fees remaining input field.',
		displayPath: `${dpRoot}|Fees Remaining`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressFeeDueDate: {
		defaultValue: 'Fee Due Date',
		description: 'Label for the fee due date input field.',
		displayPath: `${dpRoot}|Fee Due Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressCompletionPercentage: {
		defaultValue: 'Completion Percentage',
		description: 'Label for the completion percentage input field.',
		displayPath: `${dpRoot}|Completion Percentage`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPCeVoucherProgressViewButton: {
		defaultValue: 'View Credential',
		description: 'Label for the view button.',
		displayPath: `${dpRoot}|View Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const sPVoucherFeeBatchesLocKeys =
	MapLocKeys<SPVoucherFeeBatchesLocs>(sPVoucherFeeBatchesLocs);

export type SPVoucherFeeBatchesLocKeys = typeof sPVoucherFeeBatchesLocKeys;
